import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from '@denishussar/html5-game-engine';
import { ExchangeModel } from '../Models/ExchangeModel';
import { ExchangeController } from './ExchangeController';
import { MiniGameTypeEnum } from '../../../../../Models/Game/MiniGameModel';
import { GameLogic } from '../../../../../Logic/GameLogic';

export interface IRootControllerOptions {
}

export class ExchangeRootController extends SimpleBaseController {
    $model: ExchangeModel;

    public constructor(
        @Inject private _options: IRootControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('RootController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {
            childControllers: {
                ExchangeController: {
                    view: ExchangeController,
                    model: this.$model,
                    options: {
                        onComplete: () => this._gameLogic.onMiniGameComplete(MiniGameTypeEnum.currency_exchange)
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}
